import { useRef } from 'react';
import useIntersection from 'react-use/lib/useIntersection';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  Paper,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableHeadProps,
  makeStyles,
} from '@material-ui/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Alert } from '@material-ui/lab';

import { LoadingOverlay } from './LoadingOverlay';

const useTableContainerStyles = makeStyles({
  wrapper: {
    position: 'relative',
  },
  tableContainer: {
    display: 'initial',
    border: 'none',
    '& th': {
      fontWeight: 'bold',
    },
    '& > table': {
      borderCollapse: 'unset',
    },
  },
});

const useTableHeadStyles = makeStyles(
  theme => ({
    tableHeader: ({ topOffset }: { topOffset: number }) => ({
      position: 'sticky',
      top: topOffset,
      zIndex: 1,
      background: theme.palette.background.default,
    }),
  }),
  { name: 'StickyTableContainer' },
);

export const StickyTableContainer = ({
  children,
  loading = false,
  error,
}: TableContainerProps & { loading?: boolean; error?: Error | null }) => {
  const classes = useTableContainerStyles();
  const intersectionRef = useRef(null);
  const intersection = useIntersection(intersectionRef, {});

  return (
    <Paper
      className={classes.wrapper}
      ref={intersectionRef}
      variant="elevation"
      elevation={0}
    >
      <LoadingOverlay
        style={{
          top: 50,
        }}
        loading={loading}
        height={intersection?.intersectionRect.height}
      />
      {error && <Alert severity="error">{error.message}</Alert>}
      <TableContainer component={Paper} className={classes.tableContainer}>
        {children}
      </TableContainer>
    </Paper>
  );
};

export const StickyTableHead = ({
  children,
  topOffset = 0,
}: TableHeadProps & { topOffset?: number }) => {
  const classes = useTableHeadStyles({ topOffset });
  return (
    <TableHead
      data-component="StickyTableHeader"
      className={classes.tableHeader}
    >
      {children}
    </TableHead>
  );
};
